<template>
  <div class="file-uploader">
    <input
      ref="file"
      type="file"
      :accept="accept"
      @change="onFileSelected"
      hidden
    />

    <button class="btn btn-primary" @click="selectFile">
       {{ get_Info}}
    </button>

    <span class="ml-2" v-if="fileName">
      {{ fileName }}
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    accept: {
      type: String,
      default: "*"
    }
  },

  data() {
    return {
      fileName: ""
    }
  },

  computed: {
    ...mapState("auth", ["user", "is_logged", "is_csf"]),
    get_Info(){
      if(this.is_csf){
         return "Actualizar CSF";
      }
      else{
         return "Seleccionar CSF";
      }   
    }   
  },  
  methods: {
    selectFile() {
      this.$refs.file.click();
    },
    onFileSelected(event) {
        const file = event.target.files[0];

        if (!file) return;

        this.toBase64(file).then(base64 => {

            const image = {
                file: base64,
                name: file.name,
                type: file.type,
                size: file.size,
                lastModifier: new Date(file.lastModified)
            };

            this.$emit("selected", image);
        });
    },
    toBase64(file) {
        return new Promise((resolve, reject) => {

            const reader = new FileReader();

            reader.readAsDataURL(file);

            reader.onload = () => {
                // reader.result =
                // data:text/xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIi...
                resolve(reader.result.split(",")[1]);
            };

            reader.onerror = error => reject(error);
        });
    }
  }
}
</script>